/**
 * Created by wjh on 2018/1/25.
 */

//https://ce7.midea.com/ms/modelversion/index.html?model=FZ4086

  export default function getGoodsId(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
    const r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r !== null) {
        return unescape(r[2])
    };
    return null; // 返回参数值
  }




// WEBPACK FOOTER //
// ./src/components/common/getGoodsId.js